export default __webpack_public_path__ + "static/media/youtube_capture.ada74ecd.png";